import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  Box,
  Flex,
  Text,
  useColorModeValue,
  Icon,
  Collapse,
  VStack,
  Divider,
  HStack,
} from "@chakra-ui/react";
import CoreSellLogo from "../CoreSellLogo";

// ==========================================
// کامپوننت اصلی سایدبار (ادغام شده)
// ==========================================
export default function Sidebar({ routes, sidebarVariant }) {
  const location = useLocation();
  const [state, setState] = React.useState({});

  // 🎨 متغیرهای رنگی (پشتیبانی از Dark/Light Mode)
  let sidebarBg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.100", "whiteAlpha.200");
  
  const activeBg = useColorModeValue("blue.50", "whiteAlpha.100");
  const activeIconBg = "linear-gradient(135deg, #3b82f6 0%, #06b6d4 100%)"; // Blue to Cyan gradient
  const activeColor = useColorModeValue("blue.600", "white");
  
  const inactiveColor = useColorModeValue("gray.500", "gray.400");
  const inactiveIconBg = useColorModeValue("gray.100", "whiteAlpha.100");
  const inactiveIconColor = useColorModeValue("gray.500", "gray.400");
  const hoverBg = useColorModeValue("gray.50", "whiteAlpha.50");
  const hoverTextColor = useColorModeValue("gray.700", "white");

  let sidebarRadius = "0px";

  // تنظیمات استایل Opaque (باکسی)
  if (sidebarVariant === "opaque") {
    sidebarRadius = "24px";
  }

  // بررسی فعال بودن لینک فعلی
  const activeRoute = (routeName) => {
    return location.pathname === routeName;
  };

  // تابع بازگشتی برای ساخت لینک‌ها و زیرمنوها
  const createLinks = (routes) => {
    return routes.map((prop, key) => {
      if (prop.redirect) return null;

      // 🗂️ رندر دسته‌بندی‌ها (Categories)
      if (prop.category) {
        return (
          <Box key={prop.name} mt={4} mb={2}>
            <Text
              color={inactiveColor}
              fontWeight="black"
              fontSize="xs"
              letterSpacing="wider"
              px={4}
              py={2}
              opacity={0.7}
            >
              {document.documentElement.dir === "rtl" ? prop.rtlName : prop.name}
            </Text>
            <VStack align="stretch" spacing={1} mt={1}>
              {createLinks(prop.views)}
            </VStack>
          </Box>
        );
      }

      // 🔗 رندر لینک‌های عادی
      const isActive = activeRoute(prop.path);

      return (
        <NavLink to={prop.path} key={prop.name} style={{ width: "100%" }}>
          <Flex
            align="center"
            px={3}
            py={3}
            mx={2}
            borderRadius="xl"
            bg={isActive ? activeBg : "transparent"}
            color={isActive ? activeColor : inactiveColor}
            fontWeight={isActive ? "bold" : "medium"}
            transition="all 0.2s"
            _hover={{
              bg: isActive ? activeBg : hoverBg,
              transform: isActive ? "none" : "translateX(-4px)",
              color: isActive ? activeColor : hoverTextColor,
            }}
          >
            {/* آیکون */}
            <Flex
              align="center"
              justify="center"
              w="36px"
              h="36px"
              borderRadius="lg"
              bg={isActive ? activeIconBg : inactiveIconBg}
              color={isActive ? "white" : inactiveIconColor}
              me={3}
              boxShadow={isActive ? "0 4px 12px rgba(59, 130, 246, 0.3)" : "none"}
              transition="all 0.2s"
            >
              {typeof prop.icon === "string" ? (
                <Icon as={prop.icon} boxSize={4} />
              ) : (
                prop.icon
              )}
            </Flex>
            
            {/* متن لینک */}
            <Text fontSize="sm" mt="2px">
              {document.documentElement.dir === "rtl" ? prop.rtlName : prop.name}
            </Text>
            
            {/* نشانگر سمت راست برای آیتم فعال */}
            {isActive && (
              <Box 
                w="4px" 
                h="20px" 
                bg="blue.500" 
                borderRadius="full" 
                position="absolute" 
                left="16px" 
              />
            )}
          </Flex>
        </NavLink>
      );
    });
  };

  return (
    <Box
      display={{ base: "none", xl: "block" }}
      position="fixed"
      zIndex={20}
      top={sidebarVariant === "opaque" ? "16px" : "0"}
      right={sidebarVariant === "opaque" ? "16px" : "0"}
    >
      <Box
        bg={sidebarBg}
        w="280px"
        h={sidebarVariant === "opaque" ? "calc(100vh - 32px)" : "100vh"}
        m="0"
        borderRadius={sidebarRadius}
        borderInlineEnd={sidebarVariant === "opaque" ? "none" : "1px solid"}
        borderColor={borderColor}
        boxShadow={sidebarVariant === "opaque" ? "0 4px 20px -2px rgba(0,0,0,0.05)" : "none"}
        overflowY="auto"
        overflowX="hidden"
        transition="all 0.2s"
        className="custom-scrollbar"
      >
        {/* هدر سایدبار (لوگو) */}
        <VStack pt={8} pb={4} spacing={4}>
          <CoreSellLogo to="/dashboard" variant="dark" size="sm" />
          
          <Box w="full" px={6}>
            <Divider borderColor={borderColor} opacity={0.6} />
          </Box>
        </VStack>

        {/* محتوای لینک‌ها */}
        <VStack align="stretch" spacing={1} mt={4} mb={10}>
          {createLinks(routes)}
        </VStack>

      </Box>

      {/* استایل اسکرول‌بار اختصاصی */}
      <style>
        {`
          .custom-scrollbar::-webkit-scrollbar { width: 4px; }
          .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
          .custom-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
          .dark .custom-scrollbar::-webkit-scrollbar-thumb { background: #475569; }
        `}
      </style>
    </Box>
  );
}